import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { useTranslation } from 'react-i18next';
import { Languages } from '@sbercloud/ft-config-i18n';
import { I18N_NS } from './constants';

/** Является ли поле дескриптором перевода */
export var isTextDescriptor = function isTextDescriptor(item) {
  return 'value' in item && 'description' in item && typeof item.value === 'string' && typeof item.description === 'string';
};

/** Переводит объект хранения текстов в обычный словарь переводов */
export var normalizeTexts = function normalizeTexts(textSource) {
  return Object.fromEntries(Object.entries(textSource).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      item = _ref2[1];
    return [name, isTextDescriptor(item) ? item.value : normalizeTexts(item)];
  }));
};

/** Хук переводов с неймспейсом */
export var useCommonTranslations = function useCommonTranslations(i18next) {
  return useTranslation(I18N_NS, {
    i18n: i18next
  });
};

/** Функция слияния AdditionalResources объектов */
export var mergeTranslations = function mergeTranslations() {
  var naturalLanguages = Object.values(Languages).filter(function (lang) {
    return lang !== Languages.CIMode;
  });
  for (var _len = arguments.length, translations = new Array(_len), _key = 0; _key < _len; _key++) {
    translations[_key] = arguments[_key];
  }
  return translations.reduce(function (result, translation) {
    var _iterator = _createForOfIteratorHelper(naturalLanguages),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var lang = _step.value;
        result[lang] = _objectSpread(_objectSpread({}, result[lang]), translation[lang]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return result;
  }, {});
};